import { BaseError, createErrorBuilder, } from '@wix/public-editor-platform-errors';
export var PanelsErrorCode;
(function (PanelsErrorCode) {
    PanelsErrorCode["EmptyApplicationDefId"] = "EmptyApplicationDefId";
})(PanelsErrorCode || (PanelsErrorCode = {}));
class PanelsError extends BaseError {
    constructor(message, code) {
        super(message, code, 'PanelsError Private API Error');
    }
}
export const createPanelsError = createErrorBuilder(PanelsError);
//# sourceMappingURL=errors.js.map